import ChangeAuditBlock from "../../components/personal/ChangeAuditPage/ChangeAuditBlock";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const ChangeAuditPage = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Редактирование аудита"}>
            <ChangeAuditBlock/>
        </TypicalPageStructure>
        </>
    )
}

export default ChangeAuditPage;